import Vue from 'vue'
import Vuex from 'vuex'
import localStorage from "../utils/localStorage";
import mutations from "./mutations";
import actions from "./actions";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token:localStorage.get("token") || "",
    username:localStorage.get("username") || "",
    userinfo:localStorage.get("userInfo") || "",
    personName:localStorage.get("personName") || "",
    phoneNumber:localStorage.get("phoneNumber") || "",
    deliveryIdnumber:localStorage.get("deliveryIdnumber") || "",
    deliveryId:localStorage.get("deliveryId") || "",
    userId:localStorage.get("userId") || "",
    accessToken:localStorage.get("accessToken") || "",
    personId:localStorage.get("personId") || "",
    orgunit:localStorage.get("orgunit") || "",
  },
  mutations,
  actions,
  modules: {
  }
})
